//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { compressAccurately } from 'image-conversion';
import {rsaDecryFn} from "@/utils/commons";
export default {
  name: "file-upload",
  props: {
    isEdit: {
      default: () => {
        return true;
      },
    },
    attachment: {
      default: () => {
        return { id: "", attachFile: [] };
      },
    },
    limitNumber: {
      default: () => {
        return 3;
      },
    },
    mobileUploadType: {
      type: String,
    },
    autoUpload: {
      default: () => {
        return true;
      },
    },
  },
  components: {
    compressAccurately
  },
  data() {
    return {
      uploadUrl: process.env.API_ROOT,
      fileList: [],
      defaultAttachment: {},
      uploadType: this.mobileUploadType ? this.mobileUploadType : "",
    };
  },
  created() {
    this.getSystemInfo();
  },
  mounted() {
    this.getAttachment();
  },
  watch: {
    attachment() {
      this.getAttachment();
    },
    deep: true,
  },
  methods: {
    getAttachment() {
      if (this.attachment instanceof Object) {
        this.fileList = this.attachment.attachFile;
        this.defaultAttachment = this.attachment;
      } else {
        this.defaultAttachment = {};
        this.fileList = [];
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("仅支持图片！上传其他附件，请通过PC端操作!");
      }
      // 注意这里需要用Promise函数来阻止图片没有压缩好,就直接将文件上传
      return new Promise(async (resolve, reject) => {
        const isJPG = file.type === 'image/jpeg';
        const isPng = file.type === 'image/png';
        // 每个限制返回错误信息   都需要用到reject()
        if (!isJPG && !isPng) {
          this.$message.warning('上传图片只能是 JPG 或者 PNG 格式!');
          return reject(false);  //注意这里需要用reject来返回错误的信息,防止图片自动上传
        }
        let compress = 2048  // 假设图片限制不能大于2M
        let sizeOver = file.size / 1024 > compress; //文件大小 是否大于指定大小
        if (sizeOver && compress) { //大于2M进行压缩
          const res = await compressAccurately(file, {
            size: compress, //需要压缩的大小
            accuracy: 0.4, //精度 0.8-0.99之间 默认值0.95
            type: 'image/jpeg',
            width: 105,
            height: 105,
            orientation: 2,
            scale: 0.5,
          });
          file = res; //把得到的新的图片文件赋值给原文件,然后进行上传
        }
        resolve(true) // 通过resolve将Promise函数返回成功回调,进行后面操作
      })
    },
    handlePreview(file) {
       console.log(1111);
      if (file && file.key) {
        window.location.href = `${process.env.API_ROOT}api/file/download/${file.key}?_allow_anonymous=true`;
      }
    },
    //上传成功
    uploadSuccess(file) {
      if (!this.fileList) {
        this.fileList = [];
      }
      this.fileList.push(file);
      this.defaultAttachment.attachFile = this.fileList;
      this.$emit("change", this.defaultAttachment);
  },
    handleExceed() {
      this.$vux.toast.text("当前限制选择" + this.limitNumber + "个文件");
    },
    handleRemove(file) {
      if (this.fileList && this.fileList.length > 0) {
      } else {
        this.fileList = [];
      }
      this.fileList = this.fileList.filter((val) => val.uid != file.uid);
      this.defaultAttachment.attachFile = this.fileList;
      this.$emit("change", this.defaultAttachment);
  },
    uploadError() {
      this.$vux.toast.text("文件上传失败");
    },
    getSystemInfo() {
       console.log(1111);
      if (!this.uploadType) {
        this.$get("api/system-config/basic").then((data) => {
          switch (data.ossType) {
            case 1:
              this.uploadType = "aliaOss";
              break;
            case 2:
              this.uploadType = "qiniuOss";
              break;
            case 4:
              this.uploadType = "diyOss";
              break;
            case 6:
              this.uploadType = "hwOss";
              break;
            default:
              this.uploadType = "default";
              break;
          }
        });
      }
    },
    // 获取阿里oss配置
    aliaCustomReq(e) {
       console.log(1111);
      this.$get("api/oss/ali/sign?_allow_anonymous=true").then((res) => {
        if (res && res.accessid) {
          res.accessid = rsaDecryFn(res.accessid);
        }
        if (res && res.accessKey) {
          res.accessKey = rsaDecryFn(res.accessKey);
        }
        const serve = res;
        const formData = new FormData();
        let now = new Date().getTime();
        let newFile = {};
        for (let item in e.file) {
          newFile[item] = e.file[item];
        }
        formData.append("key", serve.dir + now + "_" + e.file.name);
        formData.append("OSSAccessKeyId", serve.accessid);
        formData.append("policy", serve.policy);
        formData.append("Signature", serve.signature);
        formData.append("callback", serve.callback);
        formData.append("success_action_status", "200");
        formData.append("file", e.file);
        this.$post(serve.host, formData, {
          "Content-Type": "multipart/form-data",'Access-Control-Allow-Origin': '*'
        }).then((data) => {
          if (data) {
            newFile.url = data["host"] + "/" + data["filename"];
            if (!this.fileList) {
              this.fileList = [];
            }
            this.fileList.push(newFile);
            this.defaultAttachment.attachFile = this.fileList;
            this.$emit("change", this.defaultAttachment);
        }
        });
      });
    },
    // 阿里云文件下载
    AliPreview(file) {
      console.log(1111);
      this.$get("api/oss/ali/sign?_allow_anonymous=true").then((res) => {
        if (res && res.accessid) {
          res.accessid = rsaDecryFn(res.accessid);
        }
        if (res && res.accessKey) {
          res.accessKey = rsaDecryFn(res.accessKey);
        }
        // 引入ali-oss文件
        let OSS = require("ali-oss");
        //https://help.aliyun.com/document_detail/111371.html 阿里云官方文档
        let client = new OSS({
          // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou
          region: res.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）
          accessKeyId: res.accessid,
          accessKeySecret: res.accessKey,
          // 填写Bucket名称。
          bucket: res.bucket,
        });

        let objName = file.url.replace(res.host + "/", "").replace(res.customName + "/", "");
        if (objName.includes("?")) {
          objName = objName.substring(0, objName.indexOf("?"));
        }

        let newUrl = client.signatureUrl(objName, {expires: 900});
        newUrl = newUrl.replace(res.host, res.customName);
        window.location.href = newUrl;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/file-upload.vue